export default __webpack_public_path__ + "6b2048a05a140c33ca2ffebfdd395880.png";